import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { UserRole } from '../../types/auth';

interface ClientRouteProps {
    children: React.ReactNode;
}

/**
 * Защищенный маршрут для клиентской части приложения
 * Доступен ТОЛЬКО для пользователей с ролью CLIENT
 */
export const ClientRoute: React.FC<ClientRouteProps> = ({ children }) => {
    const { user, isLoading, isAuthenticated } = useAuth();

    // Показываем загрузку
    if (isLoading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
            </div>
        );
    }

    // Если пользователь не авторизован
    if (!isAuthenticated || !user) {
        console.log('ClientRoute: пользователь не авторизован, редирект на /auth');
        return <Navigate to="/auth" replace />;
    }

    // Проверяем роль пользователя
    const userRole = user.role as UserRole;
    console.log('ClientRoute: user =', user);
    console.log('ClientRoute: userRole =', userRole);

    // Если роль НЕ CLIENT - редиректим на админ-панель
    if (userRole !== UserRole.CLIENT && userRole !== UserRole.EMPLOYEE) {
        console.log('ClientRoute: пользователь не является клиентом, редирект на админ-панель');

        // Определяем куда редиректить админов/модераторов/подписантов
        if (userRole === UserRole.SUPER_ADMIN || userRole === UserRole.MODERATOR) {
            return <Navigate to="/admin/moderation" replace />;
        } else if (userRole === UserRole.SIGNATORY) {
            return <Navigate to="/admin/client-contracts" replace />;
        }

        // На всякий случай редирект на админ логин
        return <Navigate to="/admin" replace />;
    }

    console.log('ClientRoute: пользователь является клиентом, показываем контент');
    return <>{children}</>;
};

